var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("login-layout", [
    _c("div", { staticClass: "text-center" }, [
      _vm.processing
        ? _c("div", [
            _c("h3", [_vm._v("Your email address is being verified")]),
            _vm._v(" "),
            _c("p", [_vm._v("Please wait...")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.processing && _vm.success
        ? _c("div", [
            _c("h3", [_vm._v("Thank You!")]),
            _vm._v(" "),
            _c("p", [_vm._v("Your email address has been verified.")]),
            _vm._v(" "),
            _c("div", { staticClass: "flex w-full justify-center" }, [
              _c("a", { staticClass: "btn btn-dark", attrs: { href: "/" } }, [
                _vm._v("\n          Continue to Dashboard\n        "),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.processing && !_vm.success
        ? _c("div", [
            _c("h3", [_vm._v("Verification Failed")]),
            _vm._v(" "),
            _vm.error && _vm.error.status === 422
              ? _c("p", [
                  _vm._v("\n        The email verification link is invalid."),
                  _c("br"),
                  _vm._v(
                    "\n        Try logging into the dashboard and resending the verification email.\n      "
                  ),
                ])
              : _c("p", [
                  _vm._v(
                    "\n        An error occurred verifying your email address."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        If you continue to have problems please contact an administrator.\n      "
                  ),
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex w-full justify-center" }, [
              _c("a", { staticClass: "btn btn-dark", attrs: { href: "/" } }, [
                _vm._v("\n          Continue to Dashboard\n        "),
              ]),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }